import { fetch } from '../env/browser';

export interface FetchJsonResult {
  json: unknown;
  lastModified: string | null;
}

export async function fetchJson(
  url: string,
  options: RequestInit = {}
): Promise<FetchJsonResult> {
  const finalOptions: RequestInit = {
    method: 'GET',
    ...options,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      ...options.headers,
    },
  };
  const response = await fetch(url, finalOptions);
  const json = await response.json();
  const lastModified = response.headers.get('last-modified');

  return { json, lastModified };
}

export const fetchHeaders = (
  url: string,
  names: string[] = []
): Promise<(string | null)[]> =>
  fetch(url, { method: 'HEAD' }).then((res: Response) =>
    names.map((name) => res.headers.get(name))
  );
